import reduxStore from "redux/store";
import {clearResource, setResource} from "redux/actions";
import applySearchParams from "libs/applySearchParams";
import {RestRequestGET} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";


const AUDIT_USER_LIST_POPUP_RESOURCE = 'auditUserListPopup';
const AUDIT_ALLOWED_OBJECT_LIST_RESOURCE = 'auditAllowedObjectListPopup';
const AUDIT_TASK_ORGANIZATIONS_RESOURCE = 'auditTaskOrganizations';

const getUsers = async (taskId, excludeUserIds = [], page = 1, pageSize = 10, filters = {}, sort = {}) => {
    return _getList(Endpoints.AUDIT_ADMIN_USERS(taskId), excludeUserIds, AUDIT_USER_LIST_POPUP_RESOURCE, page, pageSize, filters, sort);
}

const getAllowedObjects = async (taskId, objectType, excludeObjectIds = [], page = 1, pageSize = 10, filters = {}, sort = {}) => {
    return _getList(Endpoints.AUDIT_ADMIN_ALLOWED_OBJECTS(taskId, objectType), excludeObjectIds, AUDIT_ALLOWED_OBJECT_LIST_RESOURCE, page, pageSize, filters, sort);
}

const _getList = async (endpoint, excludeIds, resource, page = 1, pageSize = 10, filters = {}, sort = {}) => {
    const {
        column,
        direction
    } = sort

    let params = {
        'page': page,
        'pageSize': pageSize,
        'excludeIds': excludeIds.join(',')
    }
    params = applySearchParams(filters, params);

    if (column) {
        params['sort[0].column'] = column
        params['sort[0].direction'] = direction.toUpperCase()
    }

    try {
        const res = await RestRequestGET(endpoint, {
            params
        });

        reduxStore.dispatch(
            setResource(resource, res)
        )
        return res;
    } catch (error) {
    }
}

const getOrganizations = async (taskId) => {
    const res = await RestRequestGET(Endpoints.AUDIT_ADMIN_ORGANIZATIONS(taskId));

    reduxStore.dispatch(
        setResource(AUDIT_TASK_ORGANIZATIONS_RESOURCE, res)
    )
}

const clearUsers = () => {
    reduxStore.dispatch(
        clearResource(AUDIT_USER_LIST_POPUP_RESOURCE)
    );
    reduxStore.dispatch(
        clearResource(AUDIT_TASK_ORGANIZATIONS_RESOURCE)
    )
}

const clearAllowedObjects = () => {
    reduxStore.dispatch(
        clearResource(AUDIT_USER_LIST_POPUP_RESOURCE)
    );
    reduxStore.dispatch(
        clearResource(AUDIT_TASK_ORGANIZATIONS_RESOURCE)
    )
}

export default {
    getUsers,
    getAllowedObjects,
    getOrganizations,
    clearUsers,
    clearAllowedObjects,
}